/**
 * Padrão visual dos botões da description bar (`actions` do PageLayout) — referência: /content.
 *
 * Uso:
 *   <Button variant="primary" size="sm" className={HEADER_PRIMARY_BUTTON}
 *           icon={<Plus className={HEADER_ICON} />}>
 *     <span className="hidden sm:inline text-xs">{t("Rótulo completo")}</span>
 *     <span className="sm:hidden text-xs">{t("Curto")}</span>
 *   </Button>
 *
 * - No máximo UM primário por página (a ação principal); o resto é secundário.
 * - Rótulo em `text-xs`, sem caixa-alta; versão curta no celular quando o rótulo é longo.
 * - `variant="outline"` no secundário e `variant="primary"` no primário (as classes abaixo
 *   ajustam cor/altura por cima da variante).
 */

export const HEADER_PRIMARY_BUTTON =
  "rounded-lg h-8! min-h-[32px]! py-1! shadow-md shadow-purple-500/20 bg-linear-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700";

// `hover:!bg/!text`: a variante `outline` do Button traz `hover:bg-purple-600 hover:text-white`
// e o `cn` do projeto não usa tailwind-merge — sem o `!`, o hover pode virar texto branco.
export const HEADER_SECONDARY_BUTTON =
  "rounded-lg h-8! min-h-[32px]! py-1! border-indigo-300 text-indigo-700 bg-indigo-50 hover:bg-indigo-100! hover:text-indigo-700!";

/** Ícone do botão secundário (o primário usa só `h-3.5 w-3.5`, herdando o branco). */
export const HEADER_SECONDARY_ICON = "h-3.5 w-3.5 text-indigo-600";

export const HEADER_ICON = "h-3.5 w-3.5";
